import Axios from 'axios';

import { Sessao } from '~/helpers/token';
import keycloack from '~/keycloak';

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  crossdomain: true,
  withCredentials: true
});

axios.interceptors.request.use(async (config) => {
  const token = Sessao('access_token') || keycloack.token;
  if (token) config.headers.Authorization = `Bearer ${token}`;

  return config;
});

axios.interceptors.response.use(
  async (config) => {
    return config;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      // localStorage.clear();
      // document.cookie += 'ASP.NET_SessionId=;Max-Age=-999999;';
      // document.cookie += 'TokenContaUnica=;Max-Age=-999999;';
      // window.location = process.env.REACT_APP_CONTA_URL;
    }

    return Promise.reject(error);
  }
);

export default axios;
